const $ = require('jquery');

module.exports = function usabilityMarkup () {
	$('dl.faq dt').addClass('adv-analytics-navigation-accordion collapsed');
};
